import { useFieldError as useVeeFieldError } from 'vee-validate';
import { computed } from 'vue';

export const useFieldError = (field) => {
  const errorMessage = useVeeFieldError(field.value.name);

  const displayedErrors = computed(() => {
    if (errorMessage.value) {
      return errorMessage.value;
    } else if (field.value.errors) {
      return field.value.errors;
    } else {
      return null;
    }
  });

  const isInvalid = computed(() => displayedErrors.value !== null);

  return { displayedErrors, isInvalid };
};
